import './index.css'

import Root from './Root'
import { ErrorService } from '../services/error'
import { QueryService } from '../services/query'
import { ApiService } from '../services/api'
import { authActions } from '../modules/auth'

ErrorService.init()

QueryService.init({
  onError: (error) => {
    console.error('Query error', error)
  },
})

ApiService.init({
  getZoomContext: authActions.getAuthContext,

  onContextInvalid: () => {
    console.log('auth error - should redirect to login')
  },
})

function App() {
  return <Root />
}

export default App
